var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2822 7.06505C12.3954 7.16486 12.5464 7.21054 12.696 7.19021C13.6971 7.00561 14.5926 6.45258 15.206 5.64021C15.8024 4.88752 16.1516 3.96897 16.206 3.01021C16.2105 2.85133 16.1406 2.69945 16.0171 2.59945C15.8936 2.49944 15.7305 2.46275 15.576 2.50021C14.6111 2.75217 13.7481 3.29721 13.106 4.06021C12.4959 4.79728 12.1446 5.71419 12.106 6.67021C12.1046 6.82115 12.1689 6.96524 12.2822 7.06505ZM19.6385 9.72573C19.0469 10.2809 18.116 11.1544 18.116 13.0102C18.1021 14.6671 19.012 16.194 20.476 16.9702C20.6571 17.052 20.7742 17.2315 20.776 17.4302C20.776 17.5002 18.676 22.5002 16.156 22.5002C15.6043 22.5002 15.2366 22.3263 14.8339 22.1359C14.346 21.9052 13.8065 21.6502 12.826 21.6502C11.8596 21.6502 11.3188 21.8979 10.8211 22.1259C10.397 22.3202 10.0042 22.5002 9.40605 22.5002C7.08605 22.5002 3.93605 17.6402 3.93605 13.2502C3.89619 12.0102 4.2045 10.7839 4.82605 9.71021C5.70265 8.22454 7.26366 7.27518 8.98605 7.18021C9.79772 7.18021 10.4622 7.41911 11.0906 7.64508C11.6546 7.84785 12.1896 8.04021 12.776 8.04021C13.3359 8.04021 13.7877 7.86489 14.2833 7.67257C14.8855 7.43894 15.5523 7.18021 16.556 7.18021C18.386 7.18021 20.116 8.50021 20.116 9.09021C20.116 9.27768 19.9141 9.46717 19.6385 9.72573Z",
    fill: "#4753EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.7562e7d0e14e3e45c14195d80f73eeda.svg";
export { ForwardRef as ReactComponent };